import React from 'react';

import PopOverMenu from '../../PopOverMenu';

import styles from './styles.scss';

const FacilityCard = ({
    facility,
    handleFacilityAction,
    handleSelectFacility,
    'data-testid': dataTestId,
}) => {
    return (
        <div
            onClick={() => handleSelectFacility(facility)}
            className={`clickable division-card d-flex flex-column justify-content-between`}
            data-testid="club-location.facility-card"
        >
            <div className="w-100 p-3 d-flex flex-row justify-content-between align-items-center">
                <div className="d-flex flex-column justify-content-start align-items-start">
                    <p className={styles.facilityName} data-testid={dataTestId && `${dataTestId}.name`}>{facility.name}</p>
                    <p className="mt-1 mb-4" data-testid={dataTestId && `${dataTestId}.abbreviation`}>{facility.abbreviation}</p>
                </div>
                <div className="d-flex flex-column justiy-content-start align-self-start">
                    <PopOverMenu
                        horizontalEllipsis={false}
                        menuItems={[{ label: 'Edit', value: 'edit' }, { label: 'Archive', value: 'archive' }]}
                        onSelected={selected => handleFacilityAction(selected, facility)}
                        data-testid={dataTestId && `${dataTestId}.menu`}
                    />
                </div>
            </div>
            <div className="footer">
                <div className="row d-flex flex-row justify-content-around">
                    <div className="col-3">
                        <div className="title" data-testid={dataTestId && `${dataTestId}.court-amount-label`}>
                            Courts
                            <i className="fas fa-plus ml-2" />
                        </div>
                        <div className="value" data-testid={dataTestId && `${dataTestId}.court-amount`}>{facility.courtAmount}</div>
                    </div>
                    <div className="col-4">
                        <div className="title" data-testid={dataTestId && `${dataTestId}.surface-type-label`}>Surface Type</div>
                        <div className="value text-capitalize" data-testid={dataTestId && `${dataTestId}.surface-type`}>{facility.surfaceType}</div>
                    </div>
                    <div className="col-3">
                        <div className="title" data-testid={dataTestId && `${dataTestId}.type-label`}>Type</div>
                        <div className="value text-capitalize" data-testid={dataTestId && `${dataTestId}.type`}>{facility.type}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FacilityCard;
